const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Docks/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Docks/Search')

export default [
  {
    path: 'docks/create',
    name: 'DocksCreate',
    component: Single,
    meta: {
      title: 'Adicionar Doca',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'docks',
        action: 'create'
      }
    }
  },
  {
    path: 'docks/:id',
    name: 'DocksEdit',
    component: Single,
    meta: {
      title: 'Editar Doca',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'docks',
        action: 'read'
      }
    }
  },
  {
    path: 'docks',
    name: 'DocksSearch',
    component: Search,
    meta: {
      title: 'Docas',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'docks',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/docks.js